import { Derivative } from "./derivative";
import { ETF_TYPE } from "@helpers/constants";
import { TradableDetailInterface, TradableDetailType } from "@models/interfaces/tradable_detail_types";

export class Etf extends Derivative {
	public readonly tradableDetailLabels: TradableDetailInterface[] = [
		{
			label: "daily_high",
			translationKey: "tradable_detail_label_daily_high",
			type: TradableDetailType.FIAT
		},
		{
			label: "daily_low",
			translationKey: "tradable_detail_label_daily_low",
			type: TradableDetailType.FIAT
		},
		{
			label: "monthly_volatility",
			translationKey: "tradable_detail_label_monthly_volatility",
			type: TradableDetailType.PERCENTAGE
		},
		{
			label: "high_52_w",
			translationKey: "tradable_detail_label_high_52_w",
			type: TradableDetailType.FIAT
		},
		{
			label: "low_52_w",
			translationKey: "tradable_detail_label_low_52_w",
			type: TradableDetailType.FIAT
		},
		{
			label: "fund_size",
			translationKey: "tradable_detail_label_fund_size",
			type: TradableDetailType.FIAT
		}
	];

	public getCurrencyType(): string {
		return ETF_TYPE;
	}
}
